export default "__VITE_ASSET__CLMqqMAA__"